import { createContext, useContext } from 'react';
import { useParams } from 'src/lib/routing';
import invariant from 'tiny-invariant';

import { useChatFollowups } from './hooks/useChatFollowups';

type ChatFollowupsContextType = {
  generateFollowups: () => void;
  clearSuggestions: () => void;
  suggestions: string[];
  fetching: boolean;
};

const ChatFollowupsContext = createContext<ChatFollowupsContextType | undefined>(undefined);

export const useChatFollowupsContext = () => {
  const context = useContext(ChatFollowupsContext);

  if (!context) {
    throw new Error('useChatFollowupsContext must be used within a ChatFollowupsContextProvider');
  }

  return context;
};

export const ChatFollowupsContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { chatId } = useParams<{ chatId: string }>();

  invariant(chatId, 'chatId is required');

  const { generateFollowups, suggestions, fetching, clearSuggestions } = useChatFollowups(chatId);

  return (
    <ChatFollowupsContext.Provider value={{ generateFollowups, suggestions, fetching, clearSuggestions }}>
      {children}
    </ChatFollowupsContext.Provider>
  );
};
